
import {
orderInfo,
addAddrOrder,
saveOrder,
availableConsume
} from "@/api/moreAddrOrder"
import {
getGoodDetail
} from "@/api/goodDetails"
import {
Field,
CellGroup,
Switch,
Toast,
List,
PullRefresh,
Sticky
} from 'vant';
import {
chkLogin
} from "@/api/login"
import {
getCookie
} from "@/utils/auth"
import Api from '../../api.js'
import {
isAlipayOrWechat
} from '@/utils/common.js'
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
components: {
[Field.name]: Field,
[Switch.name]: Switch,
[Toast.name]: Toast,
Alert,
Confirm,
Loading
},
data() {
return {
message: "",
text: "",
showCoupon: false, //显示优惠券弹窗
switchValue: false, //开关
showAgreement: false, //协议显示
mobile: "",
goodsInfo: {},
orderDetail: {},
addressList: [],
addressInfo: {}, //顶部地址
totalFreight: 0,
couponSn: "", //优惠券编号
couponFee: 0, //优惠券抵用金额
coupons: [], //优惠券列表
moreAddrDesc: "", //多地址文案
showLoading:false,//显示加载中
gidciphertext:"",//密文
moreObj:{}
}
},
computed: {
surplusNum() {
return (10 - this.text.length)
},
totalOrderMoney() {
let addrLen = this.addressList.length <= 0 ? 1 : this.addressList.length;
let orderFee = 0;
let totalFee;

if(addrLen > 1 && this.orderDetail.discountType == 1){

totalFee = parseFloat(this.orderDetail.goodsFee - 20) * addrLen + this.totalFreight;
}else if(addrLen > 1 && this.orderDetail.discountType == 2){

totalFee = parseFloat(this.orderDetail.goodsFee) + parseFloat(this.orderDetail.goodsFee/2) * (addrLen - 1) + this.totalFreight;
}else if(addrLen > 1 && this.orderDetail.discountType == 3){

totalFee = parseFloat(this.orderDetail.goodsFee - 10) * addrLen + this.totalFreight;
}else{
totalFee = parseFloat(this.orderDetail.goodsFee) * addrLen + this.totalFreight;
}



if (this.couponFee > totalFee) {
orderFee = 0;
} else {
orderFee = totalFee - this.couponFee;
}


if(this.orderDetail.voucherFlag == 1){
this.getAvailableConsumeFun(orderFee,this.orderDetail.spuId);
orderFee = orderFee - this.orderDetail.shoppingVoucher;
}



return orderFee.toFixed(2)
}
},
created() {
this.getQueryParams()
},
mounted() {

},
methods: {
showCouponFn() {

for (let item in this.coupons) {

if (this.coupons[item].available) {
this.coupons[item].available = false;
} else {
this.$set(this.coupons[item], 'available', false)
}

if (this.coupons[item].forGidList != null) {
let totalSalePrice = 0; 
let outNum = 0; 
let addrLen = this.addressList.length

if (this.coupons[item].forGidList.indexOf(this.orderDetail.spuId) >=
0) {
totalSalePrice = parseFloat(this.orderDetail.salePrice) * addrLen
}
if (totalSalePrice >= this.coupons[item].orderQuota) {

if (this.coupons[item].type == 0) {
if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
this.$set(this.coupons[item], 'available', true)
}
} else {

if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
this.$set(this.coupons[item], 'available', true)
}
}
}
} else {
let totalSalePrice = 0; 
let outNum = 0; 
let addrLen = this.addressList.length
totalSalePrice = parseFloat(this.orderDetail.salePrice) * addrLen

if (this.coupons[item].type == 0) {
if (totalSalePrice >= this.coupons[item].orderQuota) {
if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
this.$set(this.coupons[item], 'available', true)
}
}
} else {

if (this.coupons[item].available) {
this.coupons[item].available = true;
} else {
this.$set(this.coupons[item], 'available', true)
}
}
}
}
this.showCoupon = true;

},
confirmCoupon() {
this.showCoupon = false
},

showAgreeMentFn() {
this.showAgreement = true
},

closeAgreement() {
this.showAgreement = false
},
getOrderInfo() {
let utm_source = getCookie('utm_source');

let first_utm_source = localStorage.getItem("first_utm_source")
if(first_utm_source == "" || first_utm_source == null || first_utm_source == "undefined"){
localStorage.setItem("first_utm_source",utm_source)
}
let proms = this.formatExtra(this.goodsInfo.extraGoods)
let params = ""
params = {
from: "H5",
utmFrom: utm_source,
interval: this.goodsInfo.deliveryPeriod,
periodsNumber: this.goodsInfo.sendNumber,
receiveDate: this.goodsInfo.getFlowerDate,
skuId: this.goodsInfo.skuId,
spuId: this.goodsInfo.gid,
type: this.goodsInfo.type,
proms: proms
}
console.log(this.goodsInfo)
this.moreObj = params;

if(this.goodsInfo.getDateType == 11 && !!!this.goodsInfo.getFlowerDate){
this.getGoodDetailFun(this.gidciphertext);
return
}
this.showLoading = true;
orderInfo(params).then(res => {
this.showLoading = false;
this.orderDetail = res.data
if (this.orderDetail.addresses != null && this.orderDetail.addresses.length > 0) {
this.addressList = this.orderDetail.addresses.map(item => {
this.totalFreight += parseFloat(item.shipmentFee)
return item
})
this.addressInfo = this.orderDetail.addresses[0]
} else {
this.totalFreight = 0;
this.addressInfo = {};
}
this.coupons = this.orderDetail.coupons
this.selCouponsFun()
})
},

getGoodDetailFun(gid) {
let that = this;
getGoodDetail(gid).then(res => {
that.showLoading = false
if (res.code == 1) {
let params = this.moreObj;
params.receiveDate = res.data.dtimes[0].date;
orderInfo(params).then(res => {
this.showLoading = false;
this.orderDetail = res.data
if (this.orderDetail.addresses != null && this.orderDetail.addresses.length > 0) {
this.addressList = this.orderDetail.addresses.map(item => {
this.totalFreight += parseFloat(item.shipmentFee)
return item
})
this.addressInfo = this.orderDetail.addresses[0]
} else {
this.totalFreight = 0;
this.addressInfo = {};
}
this.coupons = this.orderDetail.coupons
this.selCouponsFun()
})
}

})
},

getAddOrder() {
let params = {
uaid: this.goodsInfo.uaid,
addrIdx: ""
}
addAddrOrder(params).then(res => {
this.orderDetail = res.data
if (this.orderDetail.addresses != null && this.orderDetail.addresses.length > 0) {
this.addressList = this.orderDetail.addresses.map(item => {
this.totalFreight += item.shipmentFee
return item
})
this.addressInfo = this.orderDetail.addresses[0]
}
this.coupons = this.orderDetail.coupons
this.selCouponsFun()
})
},

editAddress(item) {
console.log("编辑地址-----------")
let addressUrl = "";

if (process.env.NODE_ENV == "production") {
addressUrl = "https://my.reflower.com.cn/address/toAddressList"
} else {
addressUrl = "https://my-ce.reflower.com.cn/address/toAddressList";
}
console.log(location.host, 'location.host')
window.location.href = addressUrl + '?tblId=' + this.orderDetail.freightTplId + '&type=order' + '&uaid=' + item
.addressId + '&addrIdx=' + item.index + '&url=https://' + location.host + '/moreAddrOrder&editType=edit'














},

editAddressPreFun: function(addrIdx) {
let params = {
uaid: this.goodsInfo.uaid,
addrIdx: addrIdx
}
addAddrOrder(params).then(res => {
this.orderDetail = res.data
if (this.orderDetail.addresses != null && this.orderDetail.addresses.length > 0) {
this.addressList = this.orderDetail.addresses.map(item => {
this.totalFreight += item.shipmentFee
return item
})
this.addressInfo = this.orderDetail.addresses[0]
}
this.coupons = this.orderDetail.coupons
this.selCouponsFun()
})
},

delAddress(item) {
let params = {
uaid: 0,
addrIdx: item.index
}
addAddrOrder(params).then(res => {
this.orderDetail = res.data
if (this.orderDetail.addresses != null && this.orderDetail.addresses.length > 0) {
this.addressList = this.orderDetail.addresses.map(item => {
this.totalFreight += item.shipmentFee
return item
})
this.addressInfo = this.orderDetail.addresses[0]
}
this.coupons = this.orderDetail.coupons
})
},
changeCouponFun(index, available) {
if (!available) {
return
}
let discountPrice = 0; 
let maxDiscount = 0; 
let maxDiscountCouponId = null; 
let couponFee = ""; 
let orderlist = this.orderDetail
let orderFee = 0; 
let outNum = 0; 
let addrLen = this.addressList.length

let oldItem = -1
let newItem = -1;
orderlist.coupons.map((item, index1) => {
if (item.check) {
oldItem = index1
}
})

console.log(oldItem, 'oldItem')

for (let i = 0; i < this.coupons.length; i++) {
if (i == index) {
continue
} else {
this.coupons[i].check = false
}
}

if (this.coupons[index].check) {
this.coupons[index].check = false
} else {
this.coupons[index].check = true

}
orderFee = parseFloat(this.orderDetail.salePrice) * addrLen
if (orderlist.coupons != null && orderlist.coupons.length > 0) {


if (orderlist.coupons[index].type == 0) {

if (orderlist.coupons[index].check) {
if (orderlist.coupons[index].forGidList != null) {
if (orderlist.coupons[index].forGidList.indexOf(orderlist.spuId) >= 0 && orderFee >= orderlist.coupons[
index].orderQuota) {
discountPrice = orderlist.coupons[index].value > orderFee ? orderFee : orderlist.coupons[index].value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
maxDiscountCouponId = orderlist.coupons[index].couponId; 
orderlist.coupons[index].check = true;


if (orderlist.coupons[index].value > orderFee) {
couponFee = orderFee;
} else {

couponFee = orderlist.coupons[index].value;
}
newItem = index
}
}
} else {

if (orderFee >= orderlist.coupons[index].orderQuota) {
discountPrice = orderlist.coupons[index].value > orderFee ? orderFee : orderlist.coupons[index].value;
if (discountPrice > maxDiscount) {
console.log(couponFee, 'couponFee')
maxDiscount = discountPrice;
maxDiscountCouponId = orderlist.coupons[index].couponId; 
orderlist.coupons[index].check = true;


if (orderlist.coupons[index].value > orderFee) {
couponFee = orderFee;
} else {

couponFee = orderlist.coupons[index].value;
}
}
}
}
}

} else {

}


}

this.couponFee = couponFee;
this.couponSn = maxDiscountCouponId;

},


getAvailableConsumeFun:function(orderFee,spuId){
let that = this;


let goodsPrice = 0;

if(that.couponFee > 0){

let tSalePrice = 0;
if(that.addressList.length > 0){
tSalePrice = that.orderDetail.salePrice * that.addressList.length;
}else{
tSalePrice = that.orderDetail.salePrice
}
if(tSalePrice == that.couponFee){
goodsPrice = 0;
}else{



let cNum = ((tSalePrice/that.orderDetail.totalOrderFee) * that.couponFee).toFixed(4);
let tnum =  cNum.substring(0, cNum.length - 2) + "";
goodsPrice = tSalePrice - tnum;
}
}else{

goodsPrice = that.orderDetail.salePrice
}

let rcgiList = [
{
gid:spuId,
goodsPrice:goodsPrice
}
]




availableConsume(orderFee,spuId,rcgiList).then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.orderDetail.shoppingVoucher = res.data;
} else {

}
})
},

selCouponsFun() {
let discountPrice = 0; 
let maxDiscount = 0; 
let maxDiscountCouponId = null; 
let couponFee = 0; 
let orderlist = this.orderDetail
let orderFee = 0; 
let outNum = 0; 
let addrLen = this.addressList.length <= 0 ? 1 : this.addressList.length;

orderFee = parseFloat(this.orderDetail.salePrice) * addrLen
if (orderlist.coupons != null && orderlist.coupons.length > 0) {

for (var c = 0; c < orderlist.coupons.length; c++) {

if (orderlist.coupons[c].type == 0) {

if (orderlist.coupons[c].forGidList != null) {
if (orderlist.coupons[c].forGidList.indexOf(orderlist.spuId) >= 0 && orderFee >= orderlist.coupons[c]
.orderQuota) {
discountPrice = orderlist.coupons[c].value > orderFee ? orderFee : orderlist.coupons[c].value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
maxDiscountCouponId = orderlist.coupons[c].couponId; 
orderlist.coupons[c].check = true;


if (orderlist.coupons[c].value > orderFee) {
couponFee = orderFee;
} else {

couponFee = orderlist.coupons[c].value;
}
}
}
} else {
console.log(couponFee, 'couponFee')
if (orderFee >= orderlist.coupons[c].orderQuota) {
discountPrice = orderlist.coupons[c].value > orderFee ? orderFee : orderlist.coupons[c].value;
if (discountPrice > maxDiscount) {
maxDiscount = discountPrice;
maxDiscountCouponId = orderlist.coupons[c].couponId; 
orderlist.coupons[c].check = true;


if (orderlist.coupons[c].value > orderFee) {
couponFee = orderFee;
} else {

couponFee = orderlist.coupons[c].value;
}
}
}
}
} else {

}
}
}
this.couponFee = couponFee;
this.couponSn = maxDiscountCouponId;
},

addAddress() {
console.log("添加地址-------")
let addressUrl = ""

if (process.env.NODE_ENV == "production") {
addressUrl = "https://my.reflower.com.cn/address/toAddressList"
} else {
addressUrl = "https://my-ce.reflower.com.cn/address/toAddressList";
}
console.log(location.host, 'location.host')
window.location.href = addressUrl + '?tblId=' + this.orderDetail.freightTplId + '&type=order' +
'&url=https://' + location.host + '/moreAddrOrder&editType=add'













},
getQueryParams() {
console.log(this.$route.query, 'query')
let params = this.$route.query
this.goodsInfo = this.$route.query;
this.gidciphertext = this.goodsInfo.gidciphertext;
console.log(params, 'params')

if (!!!localStorage.getItem("moreAddrDesc")) {
localStorage.setItem("moreAddrDesc", this.goodsInfo.moreAddrDesc);
}
this.moreAddrDesc = localStorage.getItem("moreAddrDesc");
if (params.uaid != undefined) {

if (params.editType == "edit") {
this.editAddressPreFun(params.addrIdx)
} else {
this.getAddOrder()
}

} else {
this.getOrderInfo()
}
},

submitOrder() {
if (this.orderDetail.blessCard) {
for (let i = 0; i < this.addressList.length; i++) {
let item = this.addressList[i]
if (item.blessingCards == "") {
Toast('请填写祝福卡！');
return false
} else if (item.blessingName == "") {
Toast('请填写签名！');
return false
}
}
}
if (this.orderDetail.standbyMobile == "") {
Toast('请填写备用手机号！');
return false
}
if (this.addressList.length <= 0) {
Toast('请选择地址！');
return false
}


let parmas = {
couponSn: this.couponSn,
couponFee: this.couponFee == "" ? 0 : this.couponFee,
orderFee: Number(this.totalOrderMoney).toFixed(2),//.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
standbyMobile: this.orderDetail.standbyMobile,
addresses: this.addressList,
consentAgree: this.orderDetail.consentAgree,
code:this.orderDetail.code
}

if(this.orderDetail.voucherFlag == 1){
parmas.shoppingVoucher = this.orderDetail.shoppingVoucher;
let newFee = Number(Number(parmas.orderFee) + this.orderDetail.shoppingVoucher).toFixed(2);
parmas.orderFee = newFee;
}

saveOrder(parmas).then(res => {
if (res.code == 1 || res.code == 4) {


if (Number(parmas.orderFee) > 0) {
let method = isAlipayOrWechat();

if (method == "wx") {
location.href = Api.wechatcart + '?code=' + res.data;
} else {

location.href = Api.alicart + '?code=' + res.data;
}
} else {

this.$router.push({
path: '/CartOrderdetail',
query: {
code: res.data
}
})
}
} else {
this.$vux.toast.text(res.desc, 'middle');
}
})
},
formatExtra(List) {
let transArr = []
let extraList = [];
if (List && List.length > 0) {
extraList = JSON.parse(List);
let tempArr = [];
for (let i = 0; i < extraList.length; i++) {
if (tempArr.indexOf(extraList[i].pid) === -1) {
transArr.push({
pid: extraList[i].pid,
skuIds: [extraList[i].skuId],
type: 1
});
tempArr.push(extraList[i].pid);
} else {
for (let j = 0; j < transArr.length; j++) {
if (transArr[j].pid == extraList[i].pid) {
transArr[j].skuIds.push(extraList[i].skuId);
break;
}
}
}
}

}
return transArr
}
},
filters: {
formatDot(val) {
var num = Number(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
return num
},

dateFormat: function(dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
},
}
}



// WEBPACK FOOTER //
// ./src/view/order/moreAddrOrder.vue